<template>
    <div class="editable-group-batch-upload">
        <upload-button :accept="acceptedMimetype" :before-upload="onBeforeUpload"></upload-button>
    </div>
</template>
<script>
import { mimetype } from "@/enums/mimetype";
import UploadButton from "@/components/Campaign/UploadButton.vue";

export default {
    name: "XlsUploadButton",
    components: { UploadButton },

    emits: ["error", "load"],

    data() {
        return {
            fileName: ""
        };
    },

    created() {
        this.acceptedMimetype = mimetype.XSLX;
    },

    methods: {
        onBeforeUpload(file) {
            if (file.type === mimetype.XSLX) {
                this.fileName = file.name;
                this.readExcel(file);

                return false;
            }

            this.$emit("error", {
                type: "filetype",
                message: "Excel(.xlsx) file"
            });
            return false;
        },

        async readExcel(file) {
            const excelJS = await import("exceljs");

            const wb = new excelJS.Workbook();
            const excelReader = new FileReader();
            excelReader.readAsArrayBuffer(file);

            excelReader.onload = async () => {
                const buffer = excelReader.result;
                const importData = { sheets: [], fileName: this.fileName };
                const workbook = await wb.xlsx.load(buffer);
                workbook.eachSheet(sheet => {
                    const sheetData = [];
                    const sheetName = sheet.name;
                    sheet.eachRow((row, rowNumber) => {
                        // ignore info row
                        if (rowNumber === 1) {
                            return;
                        }

                        // Iterate over all cells in a row (including empty cells).
                        const values = [];
                        row.eachCell({ includeEmpty: true }, cell => {
                            values.push(cell.value !== null ? cell.value.toString() : null);
                        });

                        sheetData.push(values);
                    });

                    importData.sheets.push(sheetName);
                    importData[sheetName] = {
                        sheetData
                    };
                });

                this.$emit("load", importData);
            };
        }
    }
};
</script>
